import { Injectable } from '@angular/core';
import { MinMaxDate } from '../../shared/interfaces/date';
import moment from 'moment';
import {BehaviorSubject} from "rxjs";
import {Observable} from "rxjs/internal/Observable";
import { AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  constructor() { }

  dateFormatSubject$ = new BehaviorSubject<string>(this.dateFormat);
  dateFormatOptions = [
    'DD MMM YY',
    'DD/MM/YYYY',
    'DD/MM/YY',
    'MM/DD/YY',
    'MM/DD/YYYY',
    'YY/MM/DD',
    'YYYY/MM/DD'
  ];

  setDateFormat(dateFormat: string) {
    this.dateFormatSubject$.next(dateFormat);
  }

  getDateFormat(): Observable<string> {
    return this.dateFormatSubject$.asObservable();
  }

  get dateFormat() {
    return localStorage.getItem('dateFormat') || 'DD MMM YY';
  }

  set dateFormat(value: string) {
    value ? localStorage.setItem('dateFormat', value) : localStorage.setItem('dateFormat', this.dateFormatOptions[0]) ;
  }

  getMinMaxDate(isStrictDate: boolean, departureDate: string, ...minMaxYears: number[]): MinMaxDate {
    const minDate = departureDate ? moment(departureDate).subtract(minMaxYears[1], 'years').add(1, 'day')
      : moment().subtract(minMaxYears[1], 'years').add(1, 'day');
    const maxDate = isStrictDate ? moment().subtract(minMaxYears[0], 'years')
      : departureDate ? moment(departureDate).subtract(minMaxYears[0], 'years')
        : moment().subtract(minMaxYears[0], 'years');
    const minMaxDate = new MinMaxDate();

    minMaxDate.minDate = {
      year: minDate.year(),
      month: minDate.month() + 1,
      day: minDate.date()
    };

    minMaxDate.maxDate = {
      year: maxDate.year(),
      month: maxDate.month() + 1,
      day: maxDate.date()
    };

    return minMaxDate;
  }

  formatDate(dateString: string, dateFormats: string | string[] = ['DDMMMYY', 'DD MMM YY', 'DD-MM-YY', 'DD/MM/YY', 'DD.MM.YY']) {
    return moment(dateString, dateFormats, true);
  }

  validateDate(formattedDate: any, minDate?: any, maxDate?: any): boolean {
    const formattedMoment = moment([formattedDate?.year, formattedDate?.month - 1, formattedDate?.day]);

    if (minDate) {
      const minMoment = moment([minDate.year, minDate.month - 1, minDate.day]);
      if (formattedMoment.isBefore(minMoment)) {
        return false;
      }
    }

    if (maxDate) {
      const maxMoment = moment([maxDate.year, maxDate.month - 1, maxDate.day]);
      if (formattedMoment.isAfter(maxMoment)) {
        return false;
      }
    }

    return true;
  }

  getFormattedDate(parsedDate: moment.Moment) {
    return {
      year: parsedDate.year(),
      month: parsedDate.month() + 1,
      day: parsedDate.date(),
    };
  }

  updateDateControl(
    dateString: string,
    control: AbstractControl,
    dateFieldName: string,
    minDate?: any,
    maxDate?: any,
  ): void {
    const parsedDate = this.formatDate(dateString);

    if (parsedDate.isValid()) {
      const formattedDate = this.getFormattedDate(parsedDate);
      const isValid = this.validateDate(formattedDate, minDate, maxDate);

      if (isValid) {
        control.get(dateFieldName)?.patchValue(formattedDate);
      }
    }
  }

}
